module.exports = __webpack_public_path__ + "static/img/sub_banner_pic2.1111142.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/home/sub_banner_pic2.png
// module id = UrR3
// module chunks = 31